/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FavoritesTypeEnum {
  PRODUCT = "product",
  BLOCK = "block",
}
